export default {
  showApplicantMessage: state => {
    const flag = state.settingList.find(a => a.var === 'OFFER_MODAL_APPLICANT_MESSAGE') || []
    return (flag.value === 'true')
  },
  showFeedDisplay: state => {
    const flag = state.settingList.find(a => a.var === 'ENABLE_FEED') || []
    return (flag.value === 'true')
  },
  getKeyWords: state => {
    return [ state.settingList.find(a => a.var === 'KEY_WORDS') || {} ] || []
  },
  getFollowUpTiming: state => {
    return state.settingList.find(a => a.var === 'FOLLOW_UP_TIMING') || { value: '08:00-20:00' }
  },
  getOnboardingFollowUpTiming: state => {
    return state.settingList.find(a => a.var === 'ONBOARDING_FOLLOW_UP_TIMING') || { value: '08:00-20:00' }
  },
  getDailySentValue: state => {
    return parseInt((state.settingList.find(a => a.var === 'DAILY_SENT') || { value: '0' }).value.replaceAll('-', ''))
  },
  getDailyPhoneCallsValue: state => {
    return parseInt((state.settingList.find(a => a.var === 'DAILY_PHONE_CALLS') || { value: '0' }).value.replaceAll('-', ''))
  },
  getDailyFollowUpsValue: state => {
    return parseInt((state.settingList.find(a => a.var === 'DAILY_FOLLOW_UPS') || { value: '0' }).value.replaceAll('-', ''))
  }
}
